export const Data = [
    {
        id: 1,
        day: "Monday",
        patientSeen: 8
    },
    {
        id: 2,
        day: "Tuesday",
        patientsSeen: 9
    },
    {
        id: 3,
        day: "Wednesday",
        patientSeen: 12
    },
    {
        id: 4,
        day: "Thursday",
        patientSeen: 4
    },
    {
        id: 5,
        day: "Friday",
        patientSeen: 7
    },
    {
        id: 6,
        day: "Saturday",
        patientSeen: 15
    },
    {
        id: 7,
        day: "Sunday",
        patientSeen: 2
    }
];

